/**
 * Created by Administrator on 2017/6/9.
 */
export function getRandom(max, num) {
  let arr1 = [];
  let arr2 = [];
  // 给原始数组original赋值
  for (let i = 0; i < max; i++) {
    arr1[i] = i + 1;
  }
  arr1.sort(function () {
    return 0.5 - Math.random();
  });
  for (let i = 0; i < num; i++) {
    arr2[i] = arr1[i];
  }
  arr2.sort(function (a, b) {
    return a - b;
  });
  for (let i = 0; i < num; i++) {
    if (arr2[i] < 10) {
      arr2[i] = '0' + arr2[i];
    }
    arr2[i] = arr2[i].toString();
  }
  return arr2;
}
var shakeTimeout;
export function getShark(fn) {
  /* eslint-disable */
  // 设置监听
  if (window.DeviceMotionEvent) {
    //获取移动速度，得到device移动时相对之前某个时间的差值比
    window.addEventListener('devicemotion', deviceMotionHandler, false);
  } else {
    console.log('您好，你目前所用的设置好像不支持重力感应哦！');
  }
  //播放音效
  function play() {
    shakeAudio.play();
  }
  //设置临界值,这个值可根据自己的需求进行设定，默认就3000也差不多了
  var shakeThreshold = 1000;
  //设置最后更新时间，用于对比
  var lastUpdate = 0;
  //设置位置速率
  var curShakeX = 0, curShakeY = 0, curShakeZ = 0, lastShakeX = 0, lastShakeY = 0, lastShakeZ = 0;

  function deviceMotionHandler(event) {
    //获得重力加速
    var acceleration = event.accelerationIncludingGravity;
    //获得当前时间戳
    var curTime = new Date().getTime();
    if ((curTime - lastUpdate) > 100) {
      //时间差
      var diffTime = curTime - lastUpdate;
      lastUpdate = curTime;
      //x轴加速度
      curShakeX = acceleration.x;
      //y轴加速度
      curShakeY = acceleration.y;
      //z轴加速度
      curShakeZ = acceleration.z;
      var speed = Math.abs(curShakeX + curShakeY + curShakeZ - lastShakeX - lastShakeY - lastShakeZ) / diffTime * 10000;
      if (speed > shakeThreshold) {
        //TODO 相关方法，比如：
        if (shakeTimeout) {
          clearTimeout(shakeTimeout);
        }
        shakeTimeout = setTimeout(function () {
          if (fn) {
            fn()
          }
        }, 1000)
      }
      lastShakeX = curShakeX;
      lastShakeY = curShakeY;
      lastShakeZ = curShakeZ;
    }
  }
  //预加摇一摇声音
  var shakeAudio = new Audio();
  shakeAudio.src = 'static/sound/shake_sound.mp3';
  var shake_options = {
    preload: 'auto'
  }
  for (var key in shake_options) {
    if (shake_options.hasOwnProperty(key) && (key in shakeAudio)) {
      shakeAudio[key] = shake_options[key];
    }
  }

  return {
    play:play
  }
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/common/js/util.js